import { Correlative } from "interfaces";
import { create } from "zustand";
import { OptionSelect } from '../../../../Common/Components/UI/Atoms/Select/SelectComponent';

interface CorrelativeStoreProps {
  idDelete: number;
  correlative: Correlative | null;
  isEdith: boolean;
  optionBranch: OptionSelect[];
   idBranch: string;
  setIsEdith: (isEdith: boolean) => void;
  setCorrelative: (correlative: Correlative | null) => void;
  setIdDelete: (id: number) => void;
  
  setIdBranch: (id: string) => void;
  setOptionBranch: (options: OptionSelect[]) => void;
}

export const useCorrelativeStore = create<CorrelativeStoreProps>((set) => ({
  idDelete: 0,
  correlative: null,
  isEdith: false,
  optionBranch: [],
  setIsEdith: (isEdith: boolean) => set({ isEdith }),
  setCorrelative: (correlative: Correlative | null) => set({ correlative }),
  setIdDelete: (id: number) => set({ idDelete: id }),
  
  setOptionBranch: (options) => set({ optionBranch: options }),
    idBranch: "",
  setIdBranch: (id: string) => set({ idBranch: id }),
}));
